import { IconButton, Card, Typography, Stack, Avatar, Box, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import DataTable from "examples/Tables/DataTable";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Visibility, Edit } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { getLabel, setEditData, toggleOpenEditModal } from "../../../../redux/labels";
import ModalLabel from "../Modal/ModalLabel";
import ModalEditLabelSize from "../Modal/ModalEditLabelSize";
import LabelPreview from "../Preview/LabelPreview";

const columns = [
  { Header: "preview", accessor: "preview", width: "15%", align: "left" },
  { Header: "text", accessor: "text", width: "15%", align: "left" },
  { Header: "label", accessor: "label", width: "15%", align: "left" },
  { Header: "priority", accessor: "priority", align: "left" },
  { Header: "status", accessor: "status", align: "center" },
  { Header: "start date", accessor: "startDate", align: "center" },
  { Header: "end date", accessor: "endDate", align: "center" },
  { Header: "action", accessor: "action", align: "center" },
];
const TabLabel = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const shopDomain = useSelector((state) => state.shop.shopDomain);
  const labels = useSelector((state) => state.label.list);
  const [active, setActive] = useState(false);
  const [labelIndex, setLabelIndex] = useState(0);

  useEffect(() => {
    setLoading(true);
    if (shopDomain) {
      dispatch(getLabel(shopDomain)).then((res) => setLoading(false));
    }
  }, [shopDomain]);

  const handleCloseModal = useCallback(() => {
    setActive(false);
  }, []);

  const handleActiveModal = useCallback(
    (index) => () => {
      setActive(true);
      setLabelIndex(index);
    },
    []
  );

  const handleOpenEditModal = useCallback(
    (label) => () => {
      dispatch(setEditData(label));
      dispatch(toggleOpenEditModal());
    },
    []
  );

  const checkStatus = useCallback((conditions, status) => {
    if (!status) {
      return ["deactivate", "error"];
    }
    if (conditions?.starts_at && Date.now() - Date.parse(conditions.starts_at) < 0) {
      return ["scheduled", "warning"];
    }
    if (conditions?.ends_at && Date.now() - Date.parse(conditions.ends_at) > 0) {
      return ["expire", "secondary"];
    }
    return ["active", "success"];
  }, []);

  // Memo hóa rows/table để identity không đổi khi mở modal,
  // tránh react-table reset pageIndex về 0 (autoResetPage).
  const rows = useMemo(
    () =>
      labels.map((labelItem, index) => {
        const { name, priority, status, conditions, text, design, label_type } = labelItem;
        return {
          preview: (
            <div
              style={{ width: "50px", aspectRatio: "1/1", display: "flex", alignContent: "center" }}
            >
              <LabelPreview data={labels[index]} design={design} type="label" />
            </div>
          ),
          text: (
            <Stack direction="row" spacing={2} alignItems="center">
              {label_type === 1 && <Typography variant="caption">{text}</Typography>}
            </Stack>
          ),
          label: (
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography>{name}</Typography>
            </Stack>
          ),
          priority: (
            <Box>
              <MDBadge badgeContent={`${priority}`} color="success" variant="gradient" size="sm" />
            </Box>
          ),
          status: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={checkStatus(conditions, status)[0]}
                color={checkStatus(conditions, status)[1]}
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          startDate: <Typography>{conditions?.starts_at ? conditions?.starts_at : ""}</Typography>,
          endDate: <Typography>{conditions?.ends_at ? conditions?.ends_at : ""}</Typography>,
          action: (
            <Stack direction="row" spacing={0.5}>
              <IconButton color="info" onClick={handleActiveModal(index)}>
                <Visibility />
              </IconButton>
              <IconButton color="warning" onClick={handleOpenEditModal(labelItem)}>
                <Edit />
              </IconButton>
            </Stack>
          ),
        };
      }),
    [labels, checkStatus, handleActiveModal, handleOpenEditModal]
  );

  const tableData = useMemo(() => ({ columns, rows }), [rows]);

  return (
    <>
      {shopDomain && (
        <Card sx={{ marginTop: 3 }}>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <Typography variant="h6" color="whitesmoke">
              Labels
            </Typography>
          </MDBox>
          <MDBox pt={3}>
            {loading ? (
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <CircularProgress color="info" />
              </Box>
            ) : labels.length === 0 ? (
              <Typography>{`Don't have any label`}</Typography>
            ) : (
              <DataTable
                table={tableData}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
              ></DataTable>
            )}
          </MDBox>
          <ModalLabel active={active} onClose={handleCloseModal} dataIndex={labelIndex} />
          <ModalEditLabelSize />
        </Card>
      )}
    </>
  );
};

export default TabLabel;
